<template>
	<b-card no-body>
		<DrawerFilterDIsbursement ref="drawer_filter_disbursement" @filter="setFilter($event)"/>
		<!-- <b-card-header class="border-0">
			<b-row></b-row>
		</b-card-header> -->

		<b-card-body>
			<!-- FILTERS -->
			<b-row class="d-flex d-flex-wrap align-items-start mb-3 mx-2">
				<b-col cols="auto" class="px-1 py-1">
					<el-switch v-model="filters.is_pending_apv" active-color="#0BC196" @change="getListing(true)"></el-switch>
					Pending approval only
				</b-col>
			</b-row>
			<b-row class="d-flex d-flex-wrap align-items-start mb-3 mx-2">
				<b-col cols="auto" class="px-1 py-1">
					<el-input placeholder="Search by text" v-model="filters.search_txt" @change="getListing(true)"> <i slot="prefix"
							class="el-input__icon el-icon-search"></i>
					</el-input>
				</b-col>
				<b-col cols="auto" class="px-1 py-1">
					<el-select v-model="filters.disb_status_id" multiple collapse-tags style="width:270px"
								placeholder="Filter by All Disbursement Status"
								@change="getListing(true)">
						<el-option v-for="item in listStatusDisb" :key="item.id" :label="item.name"
							:value="item.id">
						</el-option>
					</el-select>
				</b-col>
				<b-col cols="auto" class="px-1 py-1">
					<el-select v-model="filters.loan_type_ids" multiple collapse-tags  style="width:230px"
						placeholder="Filter By Loan Type"
						@change="getListing(true)">
						<el-option v-for="item in loanTypes" :key="item.id" :label="item.name"
							:value="item.id">
						</el-option>
					</el-select>	
				</b-col>
				<b-col cols="auto" class="px-1 py-1">
					<el-select v-model="filters.date_type" placeholder="Select Date Type" @change="setDateFilters">
						<el-option v-for="item in dateFilterOpt" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</b-col>
				<b-col cols="auto" class="px-1 py-1" :class="['this_month_disburse','last_month_disburse'].includes(filters.date_type) || _gHlp.isEmpty(filters.date_type) ? 'd-none': ''">
					<el-date-picker v-model="filters.date_start" value-format="yyyy-MM-dd" type="date" placeholder="Pick start date" @change="setFilter({})"></el-date-picker>
				</b-col>
				<b-col cols="auto" class="px-1 py-1" :class="['this_month_disburse','last_month_disburse'].includes(filters.date_type) || _gHlp.isEmpty(filters.date_type) ? 'd-none': ''">
					<el-date-picker v-model="filters.date_end" value-format="yyyy-MM-dd" type="date" placeholder="Pick end date" @change="setFilter({})"></el-date-picker>
				</b-col>
				<b-col cols="auto" class="px-1 py-1">
					<el-button type="gray" plain @click="$refs.drawer_filter_case.show()" icon="el-icon-s-operation">
						Filters
					</el-button>
				</b-col>
				<b-col cols="auto" class="px-1 py-1">
					<el-button type="danger" plain @click="resetFilter()" icon="el-icon-circle-close">
						Clear 
					</el-button>
				</b-col>
			</b-row>


			<!-- CARDS -->
			<b-row class="mb-3">
				<b-col cols="12" md="8" class="d-flex align-items-center">
					<div class="border rounded p-3 mx-2">
						<p>Total Cases</p>
						<h3 class="mb-0 text-primary">{{ _gHlp.getValue(tableSummary,'total_case',0) }}</h3>
					</div>
					<div class="border rounded p-3 mx-2">
						<p>Total Disbursed Amount</p>
						<h3 class="mb-0 text-primary">RM {{ !_gHlp.isEmpty(tableSummary) ? tableSummary.total_disb_amt : 0 | moneyFormatter }}</h3>
					</div>
					<div class="border rounded p-3 mx-2">
						<p>Total Remaining Amount</p>
						<h3 class="mb-0 text-primary">RM {{ !_gHlp.isEmpty(tableSummary) ? tableSummary.total_disb_pending_amt : 0 | moneyFormatter }}</h3>
					</div>
				</b-col>
			</b-row>

		</b-card-body>

		<div class="table-listings">
			<el-table ref="multipleTable" :data="tableData" style="width: 100%" @selection-change="selectionChange"
				v-loading="is_loading_table">
				<el-table-column type="selection" width="45"></el-table-column>

				<el-table-column width="80" class-name="icons-chat" fixed>
					<template slot-scope="scope">
						<MessagingBoxButton :type="'loan_case'" :profile="scope.row" />
					</template>
				</el-table-column>

				<el-table-column label="Case Ref No/ Created Date" min-width="250" label-class-name="py-0" fixed>
					<template slot="header">
						<span class="text-break">Case Ref No</span>
						<small class="d-block">Created Date</small>
					</template>
					<template slot-scope="scope">
						<div>
							<div class="d-flex align-items-center justify-content-between">
								<el-tooltip effect="dark" placement="right">
									<div slot="content" class="d-flex align-items-center">
										{{ scope.row.case_no }}
										<svg xmlns="http://www.w3.org/2000/svg" class="cursor-pointer ml-2"
											@click.prevent="_gHlp.copyToClipboard(scope.row.case_no)" width="14" height="18" viewBox="0 0 448 512">
											<path fill="currentColor"
												d="M208 0h124.1C344.8 0 357 5.1 366 14.1L433.9 82c9 9 14.1 21.2 14.1 33.9V336c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V48c0-26.5 21.5-48 48-48zM48 128h80v64H64v256h192v-32h64v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48z" />
										</svg>
									</div>
									<router-link event @click.native.prevent="$event => clickDetail(scope.row)"
										:to="'/credit-loan-case/detail/' + scope.row.case_id + '?active=disbursement'">
										<p class="font-weight-500 text-primary">
											{{ scope.row.case_no }}
										</p>
									</router-link>
								</el-tooltip>
								<span class="col-auto rounded text-white px-1 mx-2" :class="_gConst.getBgColor(scope.row.loan_type_code)" >{{ scope.row.loan_type_code }}</span>
							</div>
							<p class="bottom-line">{{ scope.row.created_at || '-' | dateFormatString }}</p>
						</div>
					</template>
				</el-table-column>

				<el-table-column label="Customer/ID" min-width="260" label-class-name="py-0 flex-wrap" fixed>
					<template slot="header">
						<span class="text-break">Customer Name</span>
						<small class="col-12 px-0 d-block">CHANNEL / ID</small>
					</template>
					<template slot-scope="scope">
						<div>
							<div class="d-flex justify-content-between align-items-center w-100">
								<el-tooltip effect="dark" placement="right">
									<div slot="content" class="d-flex align-items-center">
										{{ scope.row.name }}
										<svg xmlns="http://www.w3.org/2000/svg" class="cursor-pointer ml-2"
											@click.prevent="_gHlp.copyToClipboard(scope.row.name)" width="14" height="18" viewBox="0 0 448 512">
											<path fill="currentColor"
												d="M208 0h124.1C344.8 0 357 5.1 366 14.1L433.9 82c9 9 14.1 21.2 14.1 33.9V336c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V48c0-26.5 21.5-48 48-48zM48 128h80v64H64v256h192v-32h64v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48z" />
										</svg>
									</div>
									<p class="font-weight-500">
										{{ scope.row.name | formatUserName(20) }}
									</p>
								</el-tooltip>
								<!-- <el-tooltip effect="dark" placement="bottom">
									<div slot="content">
										Low (80% DSR & limit below 30k)
									</div>
									<div style="height: 18px; width: 18px;"
										:style="{ 'background-color': _gConst.getRiskColor(scope.row.risk) }"
										class="rounded text-center d-flex justify-content-center align-items-center">
										<svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 288 512"
											class="text-center">
											<path fill="#fff"
												d="M160 0c17.7 0 32 14.3 32 32V67.7c1.6 .2 3.1 .4 4.7 .7c.4 .1 .7 .1 1.1 .2l48 8.8c17.4 3.2 28.9 19.9 25.7 37.2s-19.9 28.9-37.2 25.7l-47.5-8.7c-31.3-4.6-58.9-1.5-78.3 6.2s-27.2 18.3-29 28.1c-2 10.7-.5 16.7 1.2 20.4c1.8 3.9 5.5 8.3 12.8 13.2c16.3 10.7 41.3 17.7 73.7 26.3l2.9 .8c28.6 7.6 63.6 16.8 89.6 33.8c14.2 9.3 27.6 21.9 35.9 39.5c8.5 17.9 10.3 37.9 6.4 59.2c-6.9 38-33.1 63.4-65.6 76.7c-13.7 5.6-28.6 9.2-44.4 11V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V445.1c-.4-.1-.9-.1-1.3-.2l-.2 0 0 0c-24.4-3.8-64.5-14.3-91.5-26.3c-16.1-7.2-23.4-26.1-16.2-42.2s26.1-23.4 42.2-16.2c20.9 9.3 55.3 18.5 75.2 21.6c31.9 4.7 58.2 2 76-5.3c16.9-6.9 24.6-16.9 26.8-28.9c1.9-10.6 .4-16.7-1.3-20.4c-1.9-4-5.6-8.4-13-13.3c-16.4-10.7-41.5-17.7-74-26.3l-2.8-.7 0 0C119.4 279.3 84.4 270 58.4 253c-14.2-9.3-27.5-22-35.8-39.6c-8.4-17.9-10.1-37.9-6.1-59.2C23.7 116 52.3 91.2 84.8 78.3c13.3-5.3 27.9-8.9 43.2-11V32c0-17.7 14.3-32 32-32z" />
										</svg>
									</div>
									<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 32 32" class="rounded bg-danger"><path fill="#fff" d="M23 20.515c0-4.615-3.78-5.141-6.817-5.563c-3.31-.46-5.183-.86-5.183-3.71C11 8.85 13.507 8 15.654 8a6.754 6.754 0 0 1 5.568 2.628l1.556-1.256A8.65 8.65 0 0 0 17 6.096V3h-2v3.022c-3.615.22-6 2.26-6 5.22c0 4.73 3.83 5.263 6.907 5.69c3.253.453 5.093.842 5.093 3.583C21 23.547 17.867 24 16 24c-3.43 0-4.878-.964-6.222-2.628l-1.556 1.256A8.438 8.438 0 0 0 15 25.965V29h2v-3.045c3.726-.304 6-2.327 6-5.44Z"/></svg>
								</el-tooltip> -->
							</div>
							<p class="mb-0 bottom-line d-flex align-items-center">
								<b-badge :pill="true" class="badge-tertiary">{{ scope.row.source || '-' }}</b-badge>
								<span class="px-2">{{ scope.row.customer_id }}</span>
							</p>
						</div>
					</template>
				</el-table-column>

				<el-table-column label="No. of Disb" min-width="120">
					<template slot="header" slot-scope="scope">
						<span class="text-break">{{ scope.column.label }}</span>
					</template>
					<template slot-scope="scope">
						<!-- <svg id="cases-svg" width="50" height="50">
							<circle cx="25" cy="25" r="18" stroke="#5d79e3" stroke-width="2" fill="#dce2f9" />
							<text x="25" y="30" text-anchor="middle" fill="#5d79e3" class="cases-text">
								{{ scope.row.qty_disbursement }}
							</text>
						</svg> -->
						<DisbursementListPopover :case_id="scope.row.case_id" :total_disbursement="scope.row.qty_disbursement" />
					</template>
				</el-table-column>

				<el-table-column label="Disbursement Status/ TAT" label-class-name="py-0 flex-wrap" min-width="200">
					<template slot="header">
						<span class="text-break">Disb. Status</span>
						<small class="col-12 px-0 d-block">TAT Date.</small>
					</template>
					<template slot-scope="scope">
						<div v-if="!_gHlp.isEmpty(scope.row.disb_status_detail)">
							<p :class="_gHlp.getValue(scope.row,'disb_status_detail.color_class') + ' top-line'">{{ _gHlp.getValue(scope.row,'disb_status_detail.name','-') }}</p>
							<div class="d-flex align-items-center">
								<svg xmlns="http://www.w3.org/2000/svg" class="mr-1" width="16" height="16" viewBox="0 0 24 24">
									<path fill="currentColor"
										d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm-.22-13h-.06c-.4 0-.72.32-.72.72v4.72c0 .35.18.68.49.86l4.15 2.49c.34.2.78.1.98-.24a.71.71 0 0 0-.25-.99l-3.87-2.3V7.72c0-.4-.32-.72-.72-.72z" />
								</svg>
								<span class="bottom-line">{{ _gHlp.formatMomentDate(scope.row.disb_tat_date, 'D MMM, YYYY') }}</span>
							</div>
						</div>
						<div v-else>
							<p class="top-line">-</p>
						</div>
					</template>
				</el-table-column>

				<el-table-column label="Total Disbursed Amt/ Remaining Amt."  label-class-name="py-0 flex-wrap" min-width="250">
					<template slot="header">
						<span class="text-break">Total Disbursed Amt</span>
						<small class="col-12 px-0 d-block">Remaining Amt.</small>
					</template>
					<template slot-scope="scope">
						<p class="top-line">RM {{ scope.row.disb_total_amt | moneyFormatter }}</p>
						<p class="bottom-line">RM {{ scope.row.disb_pending_amt | moneyFormatter }}</p>
					</template>
				</el-table-column>

				<el-table-column prop="loan_officer_name" label="Credit Officer" min-width="170">
					<template slot="header" slot-scope="scope">
						<span class="text-break">{{ scope.column.label }}</span>
					</template>
					<template slot-scope="scope">
						<b-avatar size="32px" :text="_gHlp.formatInitials(scope.row.loan_officer_name)"
							v-b-tooltip.hover="scope.row.loan_officer_name" v-if="scope.row.loan_officer_name && (scope.row.loan_officer_name != '-')"></b-avatar>
						<span v-else>-</span>
					</template>
				</el-table-column>

				<el-table-column prop="ssa_name" label="SSA" min-width="170">
					<template slot="header" slot-scope="scope">
						<span class="text-break">{{ scope.column.label }}</span>
					</template>
					<template slot-scope="scope">
						<b-avatar size="32px" :text="_gHlp.formatInitials(scope.row.ssa_name)"
							v-b-tooltip.hover="scope.row.ssa_name" v-if="scope.row.ssa_name && (scope.row.ssa_name != '-')"></b-avatar>
						<span v-else>{{ scope.row.ssa_name }}</span>
					</template>
				</el-table-column>


				<el-table-column fixed="right" width="25" align="center" class-name="px-0">
					<template>
						<el-dropdown trigger="click" style="cursor: pointer">
							<p class="el-dropdown-link mb-0 top-line">
								<b-icon icon="three-dots-vertical" scale="1.5"></b-icon>
							</p>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item>
									<!-- Eye Icon -->
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 576 512">
										<path fill="#13663E"
											d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4 142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1 3.3-7.9 3.3-16.7 0-24.6-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm144-64c0 35.3-28.7 64-64 64-7.1 0-13.9-1.2-20.3-3.3-5.5-1.8-11.9 1.6-11.7 7.4.3 6.9 1.3 13.8 3.2 20.7 13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1-5.8-.2-9.2 6.1-7.4 11.7 2.1 6.4 3.3 13.2 3.3 20.3z" />
									</svg>
									View Change Log
								</el-dropdown-item>
								<el-dropdown-item>
									<span class="text-danger">
										<!-- Trash-Can Icon -->
										<svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 576 512">
											<path fill="#DF3030"
												d="M135.2 17.7C140.6 6.8 151.7 0 163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3zM32 128H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm96 64c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16z" />
										</svg>
										Delete
									</span>
								</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</template>
				</el-table-column>

			</el-table>
		</div>

		<div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
			<div class="">
				<p class="card-category">
					Showing {{ pagination.from }} to {{ pagination.to }} of {{ pagination.total }} entries
					<span v-if="selectedRows.length">
						&nbsp; &nbsp; {{ selectedRows.length }} rows selected
					</span>
				</p>
			</div>
			<base-pagination class="pagination-no-border" :current="pagination.currentPage" :per-page="pagination.perPage"
				:total="pagination.total" @change="paginationChanged($event)">
			</base-pagination>
		</div>
	</b-card>
</template>

<script>
import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown, Tooltip, Select, Option, Button, Switch, DatePicker } from 'element-ui'
import DrawerFilterDIsbursement from '@/views/CreditLoanDisbursement/Drawers/DrawerFilterDIsbursement'
import MessagingBoxButton from '@/views/Messaging/MessagingBoxButton'
import DisbursementListPopover from '@/views/Widgets/DisbursementListPopover'
import { BasePagination } from '@/components'
import { useLoanCaseStore } from '@/stores/loanCaseStore';
import { useCustomerStore } from '@/stores/customerStore';
import { useAccessControlStore } from '@/stores/accessControlStore';
import { useCommonStore } from '@/stores/commonStore';
import clientPaginationMixin from '@/assets/js/clientPaginationMixin'
import { debounce } from '@/assets/js/httpImports.js'
import { mapState, mapActions } from 'pinia';
import { useMessagingStore } from '@/stores/messagingStore'
import _ from 'lodash';
import moment from 'moment'

export default {
	mixins: [clientPaginationMixin],
	components: {
		BasePagination,
		DrawerFilterDIsbursement,
		MessagingBoxButton,
		DisbursementListPopover,
		[DatePicker.name]: DatePicker,
		[Select.name]: Select,
		[Option.name]: Option,
		[Tooltip.name]: Tooltip,
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
		[Dropdown.name]: Dropdown,
		[DropdownItem.name]: DropdownItem,
		[DropdownMenu.name]: DropdownMenu,
		[Button.name]: Button,
		[Switch.name]: Switch,
	},
	data() {
		return {
			propsToSearch: ['name'],
			pending_only: false,
			tableData: [],
			tableSummary: {},
			tableTotalAmount: {},
			currentPage: 1,
			mode: 'listing',
			selectedRows: [],
			debouncedHandler: '',
			TableColumn: [{
				type: 'selection'
			}],
			is_loading_table: false,
			isFixed: true,
			filters:{
				has_disbursement:0,
				search_txt:'',
				status_id:[],
				disb_status_id:[],
				loan_type_ids: [],
				is_pending_apv: false,
				date_type: '',
				date_start: '',
				date_end: '',
			},
			dateFilterOpt: [
			{
				value: 'this_month_disburse',
				label: 'This Month'
			},
			{
				value: 'last_month_disburse',
				label: 'Last Month'
			},
			{
				value: 'created_at',
				label: 'Created Date'
			}, 
			{
				value: 'updated_at',
				label: 'Updated Date'
			}],
		}
	},
	created() {
		this.getListing();
	},
	mounted() {
		this.debouncedHandler = debounce(() => {
			// this.searchFinancialProposalList();
		}, 500);
	},
	computed: {
		...mapState(useCommonStore,['allStatus','loanTypes']),
		listStatusDisb(){
			return this.allStatus.filter(itm => itm.module == 'disbursement');
		}
	},
	methods: {
		...mapActions(useAccessControlStore, ['getUser']),
		...mapActions(useLoanCaseStore, ['getCaseList', 'getCase']),
		...mapActions(useCustomerStore, ['getCustomer']),
		...mapActions(useMessagingStore, ['getProfileListMessagesSummaries']),
		getFilters(){
			let filtered = {};
			let obj = this.filters;
			Object.keys(obj).forEach(key => {
					if (!_gHlp.isEmpty(obj[key])) {
							filtered[key] = obj[key];
					}
			});
			return filtered;
		},
		setFilter(obj){
			this.filters = { ...this.filters, ...obj }
			this.getListing(true)
		},
		setTabFilter(obj){
			this.filters = { ...this.filters, ...obj }
			this.getListing(true,false)
		},
		resetFilter() {
			Object.keys(this.filters).forEach(key => {
				this.filters[key] = ''
			});
			this.setFilter({})
		},
		setDateFilters(value){
			if(value == 'this_month_disburse'){
				this.filters.date_start = moment().startOf('month').format('YYYY-MM-DD')
				this.filters.date_end = moment().format('YYYY-MM-DD')
				this.setFilter({});
			}else if(value == 'last_month_disburse'){
				this.filters.date_start = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD')
				this.filters.date_end = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD')
				this.setFilter({});
			}
		},
		paginationChanged(page) {
			this.pagination.currentPage = page
			this.getListing();
		},
		selectionChange(selectedRows) {
			this.selectedRows = selectedRows
		},
		async getListing(resetPage=false, resetSum=true) {
			this.is_loading_table = true;
			const params = {
				search: this.getFilters(),
				paginate: this.pagination.perPage,
				page: (resetPage) ? 1 : this.pagination.currentPage
			};
			const dataList = await this.getCaseList(params, true);

			//INJECT CUSTOMER DETAIL
			let tableData = [];
			for (let i = 0; i < dataList.data.length; i++) {
				let el = dataList.data[i];
				el['loan_officer_name'] = await this.getUser(el.loan_officer_id, 'name', '-');
				el['sse_name'] = await this.getUser(el.sse_id, 'name', '-');
				tableData.push(el);
			}
			this.tableData = tableData
			this.tableTotalAmount = dataList.summary
			if(resetSum){
				this.tableSummary = dataList.summary
			}
			this.pagination = dataList.pagination;
			this.getProfileListMessagesSummaries('loan_case', this.tableData);
			this.is_loading_table = false;
		},
		clickDetail(item) {
			this.is_loading_table = true;
			this.getCustomer(item.customer_id)
			this.getCase(item.case_id).then(res => {
				this.$router.push('/credit-loan-case/detail/'+item.case_id+'?active=disbursement');
				this.is_loading_table = false;
			}).catch(err =>{
				this.is_loading_table = false;
			})
		}
	}
}
</script>